import type { ReactNode } from "react";
import { ModelBillingOverview } from "./overview";
import { TierGrid } from "./tier-grid";
import type { GridViewProps } from "./types";

export function SimpleView({
  tiers,
  description,
  modelName,
}: GridViewProps): ReactNode {
  return (
    <div className="max-w-screen-md">
      <ModelBillingOverview modelName={modelName} description={description}>
        {tiers.length > 0 ? (
          <div className="@container">
            <div className="flex min-h-full">
              <div className="flex flex-1 flex-col gap-4">
                <TierGrid tiers={tiers} />
              </div>
            </div>
          </div>
        ) : null}
      </ModelBillingOverview>
    </div>
  );
}
